// Basic
import { useQueries } from 'react-query';
// Queries
import queryGetPosTerminalAndSubscriptionsStats from '@/app/modules/dashboard/api/queries/getPosTerminalAndSubscriptionsStats';
import queryGetSimCardsStats from '@/app/modules/dashboard/api/queries/getSimCardsStats';
import queryGetContractsStats from '@/app/modules/dashboard/api/queries/getContractsStats';
import queryGetSimPoolsStats from '@/app/modules/dashboard/api/queries/getSimPoolsStats';
// Components
import Page from '../../../common-utils/components/structure/page/Page';
import ChartsSection from '@/app/modules/dashboard/components/sections/ChartsSection';
import GlobalStats from '@/app/modules/dashboard/components/sections/GlobalStats';
// Common
import RouteUrls from '@/app/root/enums/RouteUrls';

/**
 * @returns {JSX} Home
 */
function Home() {

    // API Calls
    const [
        getPosTerminalAndSubscriptionsStatsResponse,
        getSimCardsStatsResponse,
        getContractsStatsResponse,
        getSimPoolsStatsResponse
    ] = useQueries([
        queryGetPosTerminalAndSubscriptionsStats(true),
        queryGetSimCardsStats(true),
        queryGetContractsStats(true),
        queryGetSimPoolsStats(true)
    ]);

    const dashboardData = {
        posTerminalAndSubscriptions: {
            data: getPosTerminalAndSubscriptionsStatsResponse.data ?? [],
            isFetching: getPosTerminalAndSubscriptionsStatsResponse.isFetching,
            error: getPosTerminalAndSubscriptionsStatsResponse.error ?? null
        },
        simCards: {
            data: getSimCardsStatsResponse.data ?? [],
            isFetching: getSimCardsStatsResponse.isFetching,
            error: getSimCardsStatsResponse.error ?? null
        },
        contracts: {
            data: getContractsStatsResponse.data ?? [],
            isFetching: getContractsStatsResponse.isFetching,
            error: getContractsStatsResponse.error ?? null
        },
        simPools: {
            data: getSimPoolsStatsResponse.data ?? [],
            isFetching: getSimPoolsStatsResponse.isFetching,
            error: getSimPoolsStatsResponse.error ?? null
        }
    };

    return (
        <Page>
            <Page.Header route={RouteUrls.HOME} routeBase={RouteUrls.HOME} />
            <Page.Body dataCy='page-home'>
                <GlobalStats dashboardData={dashboardData} />
                <ChartsSection dashboardData={dashboardData} />
            </Page.Body>
        </Page>
    );
}

export default Home;